module.exports = __webpack_public_path__ + "static/media/icons_busqueda.558352d6.png";